export function setName(name:string) {
  return window.sessionStorage.setItem("name", name);
}
export function getName() {
  return window.sessionStorage.getItem("name");
}
export function setToken(token:string) {
  return window.sessionStorage.setItem("token", token);
}
export function getToken() {
  return window.sessionStorage.getItem("token");
}
export function setRefToken(token:string) {
    return window.sessionStorage.setItem("refreshToken", token);
}
export function getRefToken() {
    return window.sessionStorage.getItem("refreshToken");
}
